import { render, staticRenderFns } from "./BrRetrospectModal.vue?vue&type=template&id=553580ce&scoped=true"
import script from "./BrRetrospectModal.vue?vue&type=script&lang=js"
export * from "./BrRetrospectModal.vue?vue&type=script&lang=js"
import style0 from "./BrRetrospectModal.vue?vue&type=style&index=0&id=553580ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553580ce",
  null
  
)

export default component.exports